<template lang="pug">
.report-list-clone
    h2.section-title.pb-1 {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.title') }}
    el-card
        div.table-report-list
            el-table(:data='selectedContracts.slice(this.start, this.end)', :default-sort={ prop: 'contractNumber', order: 'descending' }, :empty-text="$t('mensagens.operacao.tabela.vazia')" highlight-current-row="", @selection-change='handleSelectionChange', v-loading='carregandoTabela', ref='tableReport')
                el-table-column(type="selection", width="55")
                el-table-column(min-width="120px" prop="contractNumber" :label="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.contractNumber')")
                    template(slot-scope='scope')
                        p {{ scope.row.contractNumber }}
                el-table-column(align="right" prop="contractVolume" :label="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.availableVolume')")
                    template(slot-scope='scope')
                        p {{ formatters.formatNumber(scope.row.avaliableVolume) }}
                el-table-column(align="right" prop="contractVolume" :label="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.addedVolume')")
                    template(slot-scope='scope')
                        p {{ formatters.formatNumber(scope.row.reportAddedVolume || scope.row.volumeSelecionado) }}
                el-table-column(min-width="120px" prop="contractDate" :label="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.contractDate')")
                    template(slot-scope='scope')
                        p {{ formatData(scope.row.contractDate) }}
                el-table-column(:label="$t('mensagens.blocoFiltros.uteis.municipio')", sortable)
                    template(slot-scope='scope')
                        span {{ scope.row.receivingLocation }}
                el-table-column(:label="$t('mensagens.comuns.acoes')" align="center")
                    template(v-slot="scope").action-buttons
                        BaseButton(type="text", icon="el-icon-view", @click="verContrato(scope.row)")
                        BaseButton(type="text", icon="el-icon-delete", style="color: var(--danger)", @click='deleteUnique(scope.row)')

            div.table-relatorio-rastreabilidade__pagination
                div.total
                    span
                    | {{ paginacao.totalElements }} {{ $tc('mensagens.relatorioRastreabilidade.tabelaListagem.resultados', paginacao.totalElements) }}
                    div(style="margin: 0 20px")
                    span
                    | {{ $t('mensagens.relatorioRastreabilidade.tabelaListagem.visualizacaoPorPagina') }}:
                    el-pagination(:current-page="paginacao.page" @size-change="handleSizeChange" :page-sizes="[10, 20, 30, 40]" :page-size="paginacao.size" layout="sizes" :total="paginacao.totalElements")
                div.prev_next
                    el-pagination(:current-page="paginacao.page" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]" :page-size="paginacao.size" layout="prev, pager, next, jumper" :total="paginacao.totalElements")
    .action-buttons
        BaseButton.delete(type="text", @click="deleteAll()") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.deleteSelect') }}
        .confirm-buttons
            BaseButton.save(type="outline", @click="sendSaveFinish(types.save)") {{ $t('mensagens.comuns.salvar') }}
            BaseButton.finish(type="primary", @click="sendSaveFinish(types.finish)") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.finishReport') }}
    ModalViewContract(
        :mostrar="mostrar",
        :contractId="contractId",
        @fechar="fecharModalViewContract"
    )
</template>
<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import ModalViewContract from '@/modules/traceability-report/views/components/modal-view-contract/ModalViewContract.vue';
import EventBus from '@/utils/eventBus';
import formatters from '@/utils/formatters';

export default {
    name: 'ReportListCloneDefault',
    components: {
        BaseButton,
        ModalViewContract
    },
    data() {
        return {
            formatters,
            idRelatorio: null,
            multipleSelection: [],
            selectedContracts: [],
            carregandoTabela: false,
            volumeOriginal: 0,
            paginacao: {
                size: 10,
                page: 0,
                totalPages: 0,
                totalElements: 0
            },
            totalizerData: [],
            reportData: [],
            types: {
                save: 'EM_PREENCHIMENTO',
                finish: 'FINALIZADO'
            },
            postData: {},
            contractId: null,
            mostrar: false,
            start: 0,
            end: 0

        };
    },
    async mounted() {
        EventBus.$on('totalizer-updated', this.passDataToTotalizer);
        EventBus.$on('report-valid-data', this.updateReportData);
        EventBus.$on('contratos-carregados', this.updateVolumeContractLoaded);
        EventBus.$on('contratos-selecionados', this.passDataSelectedContract);
        const params = this.$route.params;
        this.idRelatorio = params.id;
        await this.fetchContracts();
    },
    beforeDestroy() {
        EventBus.$off('contratos-selecionados');
    },
    methods: {
        passDataToTotalizer(data) {
            this.totalizerData = data;
        },

        updateReportData(data) {
            this.reportData = data;
        },

        updateVolumeContractLoaded(totalContractsVolume) {
            this.volumeOriginal += totalContractsVolume;
        },

        passDataSelectedContract(data) {
            const newContracts = data.filter(newContract =>
                !this.selectedContracts.some(existingContract => existingContract.id === newContract.id)
            );
            let offset = 100;
            const totalVolumeAdicionado = data
                .map(item => (item.volumeSelecionado || 0) + (item.reportAddedVolume || 0))
                .reduce((sum, current) => sum + current, 0);

            setTimeout(() => {
                if (data.length > 0) {
                    if (totalVolumeAdicionado > Number(this.reportData.reportVolume)) {
                        this.$notify.close();
                        this.$notify.warning({
                            message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.contractExceededReportVolumeAvailable'),
                            offset: offset
                        });
                    } else {
                        this.$notify.close();
                        this.$notify.success({
                            message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.selectContractSuccess'),
                            offset: offset
                        });
                    }
                    offset += 70;
                }
            }, 300);
            this.selectedContracts = [...this.selectedContracts, ...newContracts];
            this.handleReportListDisplay();
            this.paginacao.totalElements = this.selectedContracts.length;
        },

        formatadorDeTexto(texto) {
                return texto
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, '-')
                .toUpperCase();
        },

        handleSizeChange(size) {
            this.paginacao.size = size;
            this.paginacao.page = 0;
            this.handleReportListDisplay();
        },

        handleCurrentChange(page) {
            this.paginacao.page = page - 1;
            this.handleReportListDisplay();
            this.$set(this.paginacao, 'page', page);
        },

        handleReportListDisplay(deleted) {
            if (deleted) {
                this.$set(this.paginacao, 'page', deleted);
            }
            this.start = this.paginacao.page * this.paginacao.size;
            this.end = this.start + this.paginacao.size;
        },

        async fetchContracts() {
            this.carregandoTabela = true;
            const response = await RelatorioRastreabilidadeService.findReportContractsById(this.idRelatorio);
            this.selectedContracts = response.data.contracts;
            this.paginacao.totalElements = response.data.contracts.length;
            this.carregandoTabela = false;

            this.handleReportListDisplay();
            this.passValuesLoadedBus(this.selectedContracts);
        },

        passValuesLoadedBus(param) {
            EventBus.$emit('contratos-carregados-lista', param);
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        deleteUnique(row) {
            this.selectedContracts = this.selectedContracts.filter(item => item !== row);
            this.multipleSelection = this.multipleSelection.filter(item => item !== row);
            this.paginacao.totalElements = this.paginacao.totalElements - 1;
            if ((this.paginacao.page * this.paginacao.size >= this.paginacao.totalElements) && this.paginacao.page > 0) {
                this.paginacao.page -= 2;
            }
            this.handleReportListDisplay(this.paginacao.page);
            EventBus.$emit('remover-contratos', [row]);
            EventBus.$emit('contratos-carregados-lista', this.selectedContracts);
        },

        deleteAll() {
            if (this.multipleSelection.length > 0) {
                const contratosExcluidos = this.selectedContracts.filter(item =>
                    this.multipleSelection.includes(item)
                );

                this.selectedContracts = this.selectedContracts.filter(item =>
                    !this.multipleSelection.includes(item)
                );
                this.multipleSelection = [];
                this.paginacao.totalElements = this.paginacao.totalElements - contratosExcluidos.length;
                if ((this.paginacao.page * this.paginacao.size >= this.paginacao.totalElements) && this.paginacao.page > 0) {
                    this.paginacao.page -= 1;
                }
                this.handleReportListDisplay(this.paginacao.page);
                EventBus.$emit('remover-contratos', contratosExcluidos);
                EventBus.$emit('contratos-carregados-lista', []);
            } else {
                this.$notify.error({
                    message: this.$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.nenhumItemSelecionado')
                });
            }
        },

        async sendSaveFinish(type) {
            if (type === this.types.finish) {
                const isLengthValid = Object.keys(this.reportData).length === 8;
                const areAllFieldsValid = Object.values(this.reportData).every(field => field !== null && field !== undefined);
                if (!isLengthValid || !areAllFieldsValid) {
                    this.$notify.error({
                        message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.save.fieldsReportData')
                    });
                    return;
                }

                if (this.selectedContracts.length === 0) {
                    this.$notify.error({
                        message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.save.noContractsSelected')
                    });
                    return;
                }

                if (this.totalizerData[1] < Number(this.reportData.volume)) {
                    this.$notify.error({
                        message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.save.biggerVolumeAddedError')
                    });
                    return;
                }
            }

            this.postData = {
                reportNumber: Number(this.reportData.reportNumber),
                reportVolume: Number(this.reportData.reportVolume),
                culture: this.reportData.culture.nome.toUpperCase(),
                reportDate: new Date(this.reportData.reportDate).toISOString().slice(0, 16),
                status: type,
                contracts: this.selectedContracts.map(contract => ({
                    traceabilityContractId: contract.id,
                    reportContractVolume: contract.reportAddedVolume || contract.volumeSelecionado
                }))
            };

            await RelatorioRastreabilidadeService.sendSaveFinish(this.postData)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.save.success')
                    });
                    this.$router.push({ name: 'RelatorioRastreabilidade' });
                    this.postData = {};
                })
                .catch((error) => {
                    this.showCatchError(error);
                });
        },

        formatData(data) {
            const dataFormatada = new Date(data).toLocaleDateString('pt-BR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
            return dataFormatada;
        },

        verContrato(contract) {
            this.contractId = contract.id;
            this.mostrar = true;
        },

        fecharModalViewContract() {
            this.mostrar = false;
            this.contractId = null;
        },

        showCatchError(error) {
            const errorMessage = error.response?.data?.message || '';

            if (errorMessage.includes('This report number')) {
                const reportNumberMatch = errorMessage.match(/\((\d+)\)/);
                const reportNumber = reportNumberMatch ? reportNumberMatch[1] : '';

                this.$notify.error({
                    message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.reportNumberExists', { reportNumber })
                });
            } else if (errorMessage.includes('Total informed volume of contracts')) {
                const volumeMatch = errorMessage.match(/contracts \(([\d.]+)\).*report \(([\d.]+)\)/);
                const totalContractsVolume = volumeMatch ? volumeMatch[1] : '';
                const traceabilityReportVolume = volumeMatch ? volumeMatch[2] : '';

                this.$notify.error({
                    message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.volumeError', {
                        totalContractsVolume,
                        traceabilityReportVolume
                    })
                });
            } else if (errorMessage.includes('The informed contract')) {
                const contractMatch = errorMessage.match(/contract \((\d+)\)/);
                const contractNumber = contractMatch ? contractMatch[1] : '';

                this.$notify.error({
                    message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.reportList.negativeBalance', { contractNumber })
                });
            } else {
                this.$notify.error({
                    message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.save.error')
                });
            }
        }
    }
};
</script>
<style scoped lang="scss">
.report-list-clone {
    width: 100%;
    .section-title {
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        color: var(--primary-font-color);
    }
    .table-report-list {
        .el-table {
            .cell {
                word-break: break-word !important;
            }

            .action-buttons {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .table-relatorio-rastreabilidade__pagination {
            display: grid;
            grid-template-columns: 2fr auto;
            margin-top: 20px;
            margin-left: 20px;
            padding-bottom: 20px;
            @media (max-width: 768px) {
                grid-template-columns: 1fr;
            }

            .total {
                display: flex;
                align-items: center;
                @media (max-width: 768px) {
                    flex-direction: column;
                }
            }

            .prev_next {
                display: flex;
                @media (max-width: 768px) {
                    justify-content: center;
                    margin-top: 20px;
                }
            }
        }
    }

    .action-buttons {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .delete {
        color: var(--danger);
        margin-top: 5px;
        margin-left: 20px;
    }

    .confirm-buttons {
        margin-top: 10px;
        margin-right: 10px;
    }
}
</style>
